import { noop } from 'lodash-es';
import { createContext, useCallback, useContext, useState } from 'react';

const LazadaOrderReturnDetailContext = createContext<{
  checkReturnOrderItemIds: string[];
  onCheckReturnOrderItemId: (returnOrderItemId: string) => void;
  clearCheckReturnOrderItemIds: () => void;
}>({
  checkReturnOrderItemIds: [],
  onCheckReturnOrderItemId: noop,
  clearCheckReturnOrderItemIds: noop,
});

export const useLazadaOrderReturnDetailContext = () => {
  return useContext(LazadaOrderReturnDetailContext);
};

export const LazadaOrderReturnDetailProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const [checkReturnOrderItemIds, setCheckReturnOrderItemIds] = useState<string[]>([]);

  const onCheckReturnOrderItemId = useCallback((returnOrderItemId: string) => {
    setCheckReturnOrderItemIds((prev) => {
      if (prev.includes(returnOrderItemId)) {
        return prev.filter((id) => id !== returnOrderItemId);
      }
      return [...prev, returnOrderItemId];
    });
  }, []);

  const clearCheckReturnOrderItemIds = useCallback(() => {
    setCheckReturnOrderItemIds([]);
  }, []);

  return (
    <LazadaOrderReturnDetailContext.Provider
      value={{ checkReturnOrderItemIds, onCheckReturnOrderItemId, clearCheckReturnOrderItemIds }}
    >
      {children}
    </LazadaOrderReturnDetailContext.Provider>
  );
};
